"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/productSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ProductSectionTabPaneFadeShowActiveFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "all-tab" | "pain-tab" | "antibiotic-tab" | "cold-tab" | "diabetes-tab" | "heart-tab" | "nutrition-tab" | "devices-tab" */
    ariaLabelledby: string;
    /** Detected variants: "tab-pane fade show active wow fadeInUp" | "tab-pane fade" */
    className: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "all" | "pain" | "antibiotic" | "cold" | "diabetes" | "heart" | "nutrition" | "devices" */
    id: string;
    divDiv0Items?: ProductSection3466sItem[];
};

type ProductSection3466sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/doctors/products-img-1.png" | "/Templates/Doccure/img/doctors/products-img-2.png" | "/Templates/Doccure/img/doctors/products-img-3.png" | "/Templates/Doccure/img/doctors/products-img-4.png" | "/Templates/Doccure/img/doctors/products-img-5.png" | "/Templates/Doccure/img/doctors/products-img-6.png" | "/Templates/Doccure/img/doctors/products-img-7.png" | "/Templates/Doccure/img/doctors/products-img-8.png" */
    src: string;
    /** Detected variants: "Aspirin Tablets" | "Vitamin D Capsules" | "Probiotic Gummies" | "Melatonin Tablets" | "Calcium Tablets" | "Iron Supplement" | "Magnesium Capsules" | "Zinc Tablets" */
    link0Text: ReactNode;
    /** Detected variants: "Pain & Fever Relief" | "Diabetes Care" | "Antibiotics" | "Heart & BP" | "Cold, Cough & Allergy" | "Nutrition" */
    p0Text: ReactNode;
    /** Detected variants: "$30" | "$50" | "$15" | "$31" | "$18" */
    h40Text: ReactNode;
    /** Detected variants: "$36" */
    span0Text?: ReactNode;
    /** Detected variants: "24 Pieces" | "14 Pieces" | "26 Pieces" | "16 Pieces" | "17 Pieces" | "20 Pieces" */
    span0Span0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-lg-4 col-md-6 col-sm-6" */
    className?: string;
    /** Detected variants: "deals-item-thirteen" */
    div0ClassName?: string;
    /** Detected variants: "delas-overlay" */
    div0ClassName2?: string;
    /** Detected variants: "favorite" */
    button0ClassName?: string;
    /** Detected variants: "isax isax-heart" */
    i0ClassName?: string;
    /** Detected variants: "delas-badge justify-content-end" */
    div0ClassName3?: string;
    /** Detected variants: "deals" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "deals-content" */
    div1ClassName?: string;
    /** Detected variants: "title" */
    div0ClassName4?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "price-item" */
    div1ClassName2?: string;
    /** Detected variants: "count-price" */
    h40ClassName?: string;
    /** Detected variants: "count" */
    span0ClassName?: string;
    /** Detected variants: "deals-footer" */
    div2ClassName?: string;
    /** Detected variants: "Add to Cart" */
    link0Link0Text?: ReactNode;
    /** Detected variants: "btn theme-12-btn" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    link0Href?: string;
    /** Detected variants: "isax isax-shopping-cart ms-2" */
    i0ClassName2?: string;
};

type ProductSectionNavsItem = {
    key: Key | null | undefined;
    /** Detected variants: "All Categories" | "Pain & Fever Relief" | "Antibiotics" | "Cold, Cough & Allergy" | "Diabetes Care" | "Heart & BP" | "Nutrition" | "Devices" */
    button0Text: ReactNode;
    /** Detected variants: "all" | "pain" | "antibiotic" | "cold" | "diabetes" | "heart" | "nutrition" | "devices" */
    ariaControls: string;
    /** Detected variants: "true" | "false" */
    ariaSelected: boolean;
    /** Detected variants: "nav-link active" | "nav-link" */
    className: string;
    /** Detected variants: "#all" | "#pain" | "#antibiotic" | "#cold" | "#diabetes" | "#heart" | "#nutrition" | "#devices" */
    dataBsTarget: string;
    /** Detected variants: "all-tab" | "pain-tab" | "antibiotic-tab" | "cold-tab" | "diabetes-tab" | "heart-tab" | "nutrition-tab" | "devices-tab" */
    id: string;
    /** Detected variants: "tab" */
    dataBsToggle?: string;
    /** Detected variants: "nav-item" */
    liClassName?: string;
};
export type HomeThirteenProductSectionGeneratedProps = {
    divDiv0Div0Div0Button0ButtonProps?: Partial<ComponentProps<"button">> | ((item: ProductSection3466sItem) => Partial<ComponentProps<"button">>);
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ProductSection3466sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ProductSection3466sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1Div0H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ProductSection3466sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1Div1H40H4Props?: Partial<ComponentProps<"h4">> | ((item: ProductSection3466sItem) => Partial<ComponentProps<"h4">>);
    divDiv0Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ProductSection3466sItem) => Partial<ComponentProps<typeof SmartLink>>);
    liButton0ButtonProps?: Partial<ComponentProps<"button">> | ((item: ProductSectionNavsItem) => Partial<ComponentProps<"button">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Trending Products of the Week" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "#" */
    sectionDiv0Div0Link0LinkHref?: string;
    /** Default: "View All" */
    sectionDiv0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "myTabContent" */
    sectionDiv0Div1Div0DivId?: string;
    /** Default: "productsTab" */
    sectionDiv0Div1Ul0UlId?: string;
    productSectionTabPaneFadeShowActiveFadeInUps: ProductSectionTabPaneFadeShowActiveFadeInUpsItem[];
    productSectionNavs: ProductSectionNavsItem[];
    productSectionTabPaneFadeShowActiveFadeInUpsItemWrapper?: (item: ProductSectionTabPaneFadeShowActiveFadeInUpsItem, content: ReactNode) => ReactNode;
    productSectionTabPaneFadeShowActiveFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    productSection3466sItemWrapper?: (item: ProductSection3466sItem, content: ReactNode) => ReactNode;
    productSection3466sRenderer?: (defaultNode: ReactNode) => ReactNode;
    productSection3466sLinkVisible?: boolean;
    productSection3466sLinkRenderer?: (item: ProductSection3466sItem, defaultNode: ReactNode) => ReactNode;
    productSection3466sImageVisible?: boolean;
    productSection3466sImageRenderer?: (item: ProductSection3466sItem, defaultNode: ReactNode) => ReactNode;
    productSection3466sButtonVisible?: boolean;
    productSection3466sButtonRenderer?: (item: ProductSection3466sItem, defaultNode: ReactNode) => ReactNode;
    productSection3466sH3Visible?: boolean;
    productSection3466sH3Renderer?: (item: ProductSection3466sItem, defaultNode: ReactNode) => ReactNode;
    productSection3466sH4Visible?: boolean;
    productSection3466sH4Renderer?: (item: ProductSection3466sItem, defaultNode: ReactNode) => ReactNode;
    productSection3466sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ProductSection3466sItem) => Partial<ComponentProps<typeof SmartLink>>);
    productSection3466sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ProductSection3466sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    productSection3466sButtonProps?: Partial<ComponentProps<"button">> | ((item: ProductSection3466sItem) => Partial<ComponentProps<"button">>);
    productSection3466sH3Props?: Partial<ComponentProps<"h3">> | ((item: ProductSection3466sItem) => Partial<ComponentProps<"h3">>);
    productSection3466sH4Props?: Partial<ComponentProps<"h4">> | ((item: ProductSection3466sItem) => Partial<ComponentProps<"h4">>);
    productSectionNavsItemWrapper?: (item: ProductSectionNavsItem, content: ReactNode) => ReactNode;
    productSectionNavsRenderer?: (defaultNode: ReactNode) => ReactNode;
    productSectionNavsButtonVisible?: boolean;
    productSectionNavsButtonRenderer?: (item: ProductSectionNavsItem, defaultNode: ReactNode) => ReactNode;
    productSectionNavsButtonProps?: Partial<ComponentProps<"button">> | ((item: ProductSectionNavsItem) => Partial<ComponentProps<"button">>);
};

const HomeThirteenProductSectionGenerated: FC<HomeThirteenProductSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Trending Products of the Week",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0Link0LinkHref = "#",
    sectionDiv0Div0Link0LinkText = "View All",
    sectionDiv0Div0Link0LinkVisible,
    sectionDiv0Div0Link0LinkRenderer,
    sectionDiv0Div0Link0LinkProps,
    sectionDiv0Div1Div0DivId = "myTabContent",
    sectionDiv0Div1Ul0UlId = "productsTab",
    divDiv0Div0Div0Button0ButtonProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0H30H3Props,
    divDiv0Div1Div0H30Link0LinkProps,
    divDiv0Div1Div1H40H4Props,
    divDiv0Div2Link0LinkProps,
    liButton0ButtonProps,
    productSectionTabPaneFadeShowActiveFadeInUps,
    productSectionNavs,
    productSectionTabPaneFadeShowActiveFadeInUpsItemWrapper,
    productSectionTabPaneFadeShowActiveFadeInUpsRenderer,
    productSection3466sItemWrapper,
    productSection3466sRenderer,
    productSection3466sLinkVisible,
    productSection3466sLinkRenderer,
    productSection3466sImageVisible,
    productSection3466sImageRenderer,
    productSection3466sButtonVisible,
    productSection3466sButtonRenderer,
    productSection3466sH3Visible,
    productSection3466sH3Renderer,
    productSection3466sH4Visible,
    productSection3466sH4Renderer,
    productSection3466sLinkProps,
    productSection3466sImageProps,
    productSection3466sButtonProps,
    productSection3466sH3Props,
    productSection3466sH4Props,
    productSectionNavsItemWrapper,
    productSectionNavsRenderer,
    productSectionNavsButtonVisible,
    productSectionNavsButtonRenderer,
    productSectionNavsButtonProps,
}) => {
    return (
        <section className="products-section-thirteen section">
            <div className="container">
                <div className="section-header section-header-thirteen wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    {renderNode(sectionDiv0Div0Link0LinkVisible, sectionDiv0Div0Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div0Link0LinkHref} className="btn theme-12-btn" {...(sectionDiv0Div0Link0LinkProps ?? {})}>
                            {sectionDiv0Div0Link0LinkText}
                            <i className="isax isax-arrow-right-1 ms-2" />
                            {" "}
                        </SmartLink>
                    ))}
                </div>
                <div className="products-tab-thirteen">
                    <ul className="nav nav-tabs border-0" id={sectionDiv0Div1Ul0UlId} role="tablist">
                        {renderCollectionNode(
                            productSectionNavs,
                            (item: ProductSectionNavsItem) => (
                                <li className={item.liClassName ?? "nav-item"} role="presentation" key={item.key}>
                                    {renderItemNode(productSectionNavsButtonVisible, productSectionNavsButtonRenderer, item, (
                                        <button className={item.className} id={item.id} data-bs-toggle={item.dataBsToggle ?? "tab"} data-bs-target={item.dataBsTarget} type="button" role="tab" aria-controls={item.ariaControls} aria-selected={item.ariaSelected} {...(typeof productSectionNavsButtonProps === "function" ? productSectionNavsButtonProps(item) : (productSectionNavsButtonProps ?? {}))} {...(typeof liButton0ButtonProps === "function" ? liButton0ButtonProps(item) : (liButton0ButtonProps ?? {}))}>{item.button0Text}</button>
                                    ))}
                                </li>
                            ),
                            productSectionNavsItemWrapper,
                            productSectionNavsRenderer
                        )}
                    </ul>
                    <div className="tab-content" id={sectionDiv0Div1Div0DivId}>
                        {renderCollectionNode(
                            productSectionTabPaneFadeShowActiveFadeInUps,
                            (item: ProductSectionTabPaneFadeShowActiveFadeInUpsItem) => (
                                <div className={item.className} data-wow-duration={item.dataWowDuration} id={item.id} role="tabpanel" aria-labelledby={item.ariaLabelledby} key={item.key}>
                                    <div className="row g-4 justify-content-center">
                                        {renderCollectionNode(
                                            item.divDiv0Items ?? [],
                                            (item: ProductSection3466sItem) => (
                                                <div className={item.className ?? "col-xl-3 col-lg-4 col-md-6 col-sm-6"} key={item.key}>
                                                    <div className={item.div0ClassName ?? "deals-item-thirteen"}>
                                                        <div className={item.div0ClassName2 ?? "delas-overlay"}>
                                                            {renderItemNode(productSection3466sImageVisible, productSection3466sImageRenderer, item, (
                                                                <SmartImage src={item.src} alt={item.alt ?? "deals"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof productSection3466sImageProps === "function" ? productSection3466sImageProps(item) : (productSection3466sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                            ))}
                                                            <div className={item.div0ClassName3 ?? "delas-badge justify-content-end"}>
                                                                {renderItemNode(productSection3466sButtonVisible, productSection3466sButtonRenderer, item, (
                                                                    <button className={item.button0ClassName ?? "favorite"} {...(typeof productSection3466sButtonProps === "function" ? productSection3466sButtonProps(item) : (productSection3466sButtonProps ?? {}))} {...(typeof divDiv0Div0Div0Button0ButtonProps === "function" ? divDiv0Div0Div0Button0ButtonProps(item) : (divDiv0Div0Div0Button0ButtonProps ?? {}))}>
                                                                        <i className={item.i0ClassName ?? "isax isax-heart"} />
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <div className={item.div1ClassName ?? "deals-content"}>
                                                            <div className={item.div0ClassName4 ?? "title"}>
                                                                {renderItemNode(productSection3466sH3Visible, productSection3466sH3Renderer, item, (
                                                                    <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof productSection3466sH3Props === "function" ? productSection3466sH3Props(item) : (productSection3466sH3Props ?? {}))} {...(typeof divDiv0Div1Div0H30H3Props === "function" ? divDiv0Div1Div0H30H3Props(item) : (divDiv0Div1Div0H30H3Props ?? {}))}>
                                                                        {renderItemNode(productSection3466sLinkVisible, productSection3466sLinkRenderer, item, (
                                                                            <SmartLink href={item.href ?? "#"} {...(typeof productSection3466sLinkProps === "function" ? productSection3466sLinkProps(item) : (productSection3466sLinkProps ?? {}))} {...(typeof divDiv0Div1Div0H30Link0LinkProps === "function" ? divDiv0Div1Div0H30Link0LinkProps(item) : (divDiv0Div1Div0H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                                        ))}
                                                                    </h3>
                                                                ))}
                                                                <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                                            </div>
                                                            <div className={item.div1ClassName2 ?? "price-item"}>
                                                                {renderItemNode(productSection3466sH4Visible, productSection3466sH4Renderer, item, (
                                                                    <h4 className={item.h40ClassName ?? "count-price"} {...(typeof productSection3466sH4Props === "function" ? productSection3466sH4Props(item) : (productSection3466sH4Props ?? {}))} {...(typeof divDiv0Div1Div1H40H4Props === "function" ? divDiv0Div1Div1H40H4Props(item) : (divDiv0Div1Div1H40H4Props ?? {}))}>
                                                                        {item.h40Text}
                                                                        <span>{item.span0Text}</span>
                                                                    </h4>
                                                                ))}
                                                                <span className={item.span0ClassName ?? "count"}>{item.span0Span0Text}</span>
                                                            </div>
                                                        </div>
                                                        <div className={item.div2ClassName ?? "deals-footer"}>
                                                            {renderItemNode(productSection3466sLinkVisible, productSection3466sLinkRenderer, item, (
                                                                <SmartLink href={item.link0Href ?? "#"} className={item.link0ClassName ?? "btn theme-12-btn"} {...(typeof productSection3466sLinkProps === "function" ? productSection3466sLinkProps(item) : (productSection3466sLinkProps ?? {}))} {...(typeof divDiv0Div2Link0LinkProps === "function" ? divDiv0Div2Link0LinkProps(item) : (divDiv0Div2Link0LinkProps ?? {}))}>
                                                                    <i className={item.i0ClassName2 ?? "isax isax-shopping-cart ms-2"} />
                                                                    {item.link0Link0Text ?? "Add to Cart"}
                                                                </SmartLink>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            ),
                                            productSection3466sItemWrapper,
                                            productSection3466sRenderer
                                        )}
                                    </div>
                                </div>
                            ),
                            productSectionTabPaneFadeShowActiveFadeInUpsItemWrapper,
                            productSectionTabPaneFadeShowActiveFadeInUpsRenderer
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeThirteenProductSectionGenerated;
